import { PostMessage } from '../Shared/PostMessage';

export const GetAbsolutePathMessageId: string = 'ComponentCanvasProvider_GetAbsolutePath';

export interface GetAbsolutePathMessage extends PostMessage<typeof GetAbsolutePathMessageId> {}
